import { Component } from "@angular/core";
import { airQuoteHistoryService } from "../airQuoteHistory/airQuoteHistory.service";
import { ToastsManager } from "ng2-toastr/ng2-toastr";
import { FormControl } from "@angular/forms";
import { Constants } from "../constants/constants";
import { QuoteStatuses } from "../enums/enums";
import { ActivatedRoute, Router } from "@angular/router";
import "rxjs/add/operator/debounceTime";
import "rxjs/add/operator/distinctUntilChanged";

@Component({
    selector: "airQuoteHistory",
    templateUrl: "/app/airQuoteHistory/airQuoteHistory.template.html",
    providers: [airQuoteHistoryService]
})
export class AirQuoteHistoryComponent {

    airFreightQuoteHistory = [] as Array<IAirQuoteHistoryModel>;
    completedQuoteHistory = [] as Array<IAirQuoteHistoryModel>;
    filter = new FormControl();
    search = "";
    lastSortedColumnApproval = "id";
    lastSortedColumnHistory = "id";
    isDescApproval = true;
    isDescHistory = true;
    purchaseHistoryRowCount = 0;
    purchaseHistoryPageSize = 20;
    purchaseHistoryPageNumber = 1;
    completedHistoryRowCount = 0;
    completedHistoryPageSize = 20;
    completedHistoryPageNumber = 1;
    restUrl = Constants.attachtmentsUrl;
    isSave = false;
    title = "";
    firstHeader = "";
    hasManagerApprovals = false;
    selectQuote = false;

    constructor(private airQuoteHistoryService: airQuoteHistoryService, private toast: ToastsManager, private constants: Constants, private activatedRoute: ActivatedRoute, private router: Router) { }

    ngOnInit() {
        this.search = this.activatedRoute.snapshot.params["searchTerm"] ? this.activatedRoute.snapshot.params["searchTerm"] : "";

        this.isSave = this.router.url.indexOf("savedPurchases") > -1;
        this.getHasManagerApprovals();

        this.filter.valueChanges.debounceTime(500).distinctUntilChanged().subscribe((term: string) => {
            if (!this.isSave) {
                this.title = "Air Freight Quote History";
                this.firstHeader = "Open Air Freight Quotes";

                if (term) {
                    this.searchHistory(term, 1);
                    this.searchCompletedHistory(term, 1);
                } else {
                    this.getQuoteHistory();
                    this.getCompletedQuoteHistory();
                }
            } else {
                this.title = "Air Freight Saved Quotes";
                this.firstHeader = "Air Freight Saved Quotes";

                if (term)
                    this.searchSavedPurchases(term, 1);
                else
                    this.getSavedPurchases();
            }
        });
    }

    getSavedPurchases(): void {
        if (this.search && this.search.length > 0)
            this.searchSavedPurchases(this.search, this.purchaseHistoryPageNumber);
        else {
            this.airQuoteHistoryService.getSavedPurchases(this.constants.user.username, this.purchaseHistoryPageNumber, this.purchaseHistoryPageSize).subscribe((purchaseHistory: { purchases: Array<IAirQuoteHistoryModel>, rowCount: number }): void => {
                if (purchaseHistory) {
                    this.airFreightQuoteHistory = purchaseHistory.purchases;
                    this.purchaseHistoryRowCount = purchaseHistory.rowCount;
                }
            });
        }
    }

    getQuoteHistory(): void {
        if (this.search && this.search.length > 0)
            this.searchHistory(this.search, this.purchaseHistoryPageNumber);
        else {                  
            this.airQuoteHistoryService.getQuoteHistory(this.constants.user.username, this.purchaseHistoryPageNumber, this.purchaseHistoryPageSize).subscribe((purchaseHistory: { purchases: Array<IAirQuoteHistoryModel>, rowCount: number }): void => {                
                if (purchaseHistory) {
                    this.airFreightQuoteHistory = purchaseHistory.purchases;                    
                    this.purchaseHistoryRowCount = purchaseHistory.rowCount;                    
                }
            });
        }
    }

    getCompletedQuoteHistory(): void {
        if (this.search && this.search.length > 0)
            this.searchCompletedHistory(this.search, this.completedHistoryPageNumber);
        else {
            this.airQuoteHistoryService.getCompletedQuoteHistory(this.constants.user.username, this.completedHistoryPageNumber, this.completedHistoryPageSize).subscribe((completedHistory: { purchases: Array<IAirQuoteHistoryModel>, rowCount: number }): void => {
                if (history) {                      
                    this.completedQuoteHistory = completedHistory.purchases;
                    this.completedHistoryRowCount = completedHistory.rowCount;
                }
            });
        }
    }

    showHideDetails(quoteHistory: IAirQuoteHistoryModel): void {           
        if (quoteHistory.isVisible === undefined)
            quoteHistory.isVisible = false;

        quoteHistory.isVisible = !quoteHistory.isVisible;       
    }

    updateQuoteStatus(purchase: IAirQuoteHistoryModel): void {
        this.airQuoteHistoryService.updateQuoteStatus(purchase.id, QuoteStatuses.Cancelled, this.constants.user.username).subscribe((result: boolean): void => {
            if (result) {
                this.getQuoteHistory();
                this.getCompletedQuoteHistory();

                this.toast.success(`Quote ${purchase.id} has been updated.`, "Success", { toastLife: 5000 });
                
            } else {
                this.toast.error("Error processing you request.", "Error", { toastLife: 10000 });
            }
    			

    	});
    }

    searchHistory(term: string, pageNumber: number): void {
        if (term) {
            this.airQuoteHistoryService.getQuoteHistorySearch(this.constants.user.username, pageNumber, this.purchaseHistoryPageSize, term).subscribe((purchaseHistory: { purchases: Array<IAirQuoteHistoryModel>, rowCount: number }): void => {
                if (purchaseHistory) {
                    this.purchaseHistoryPageNumber = pageNumber;
                    this.airFreightQuoteHistory = purchaseHistory.purchases;
                    this.purchaseHistoryRowCount = purchaseHistory.rowCount;
                }
            });
        }
    }

    searchSavedPurchases(term: string, pageNumber: number): void {
        if (term) {
            this.airQuoteHistoryService.getQuoteHistorySearch(this.constants.user.username, pageNumber, this.purchaseHistoryPageSize, term).subscribe((purchaseHistory: { purchases: Array<IAirQuoteHistoryModel>, rowCount: number }): void => {
                if (purchaseHistory) {
                    this.purchaseHistoryPageNumber = pageNumber;
                    this.airFreightQuoteHistory = purchaseHistory.purchases;
                    this.purchaseHistoryRowCount = purchaseHistory.rowCount;
                }
            });
        }
    }

    searchCompletedHistory(term: string, pageNumber: number): void {
        if (term) {
            this.airQuoteHistoryService.getCompletedQuoteHistorySearch(this.constants.user.username, pageNumber, this.completedHistoryPageSize, term).subscribe((completedHistory: { purchases: Array<IAirQuoteHistoryModel>, rowCount: number }): void => {
                if (completedHistory) {
                    this.completedHistoryPageNumber = pageNumber;
                    this.completedQuoteHistory = completedHistory.purchases;
                    this.completedHistoryRowCount = completedHistory.rowCount;
                }
            });
        }
    }

    showApprovalArrows(column: string): boolean {
        return this.isDescApproval && this.lastSortedColumnApproval === column;
    }

    setSortOrderApproval(columnName: string) {        
        if (this.lastSortedColumnApproval === columnName)
            this.isDescApproval = !this.isDescApproval;
        else
            this.isDescApproval = true;

        this.lastSortedColumnApproval = columnName;
    }

    showHistoryArrows(column: string): boolean {
        return this.isDescHistory && this.lastSortedColumnHistory === column;
    }

    setSortOrderHistory(columnName: string) {
        if (this.lastSortedColumnHistory === columnName)
            this.isDescHistory = !this.isDescHistory;
        else
            this.isDescHistory = true;

        this.lastSortedColumnHistory = columnName;
    }

    canEdit(history: IAirQuoteHistoryModel): boolean {
        return history.status === "Waiting Manager Approval" || history.status === "Saved";
    }

    getHasManagerApprovals() {
        this.airQuoteHistoryService.getHasManagerApprovals(this.constants.user.email).subscribe((hasApprovals: boolean): void => {
            if (hasApprovals)
                this.hasManagerApprovals = hasApprovals;
        });
    }
    downloadAttachment(formTypeId:number,approvalId: number,fileName: string)
	{
		this.airQuoteHistoryService.downloadAttachment(formTypeId,approvalId,fileName).subscribe((blob) => {
			const link = document.createElement('a');
			const url = window.URL.createObjectURL(blob);
			link.href = url;
			link.download = fileName;
			link.click();
			window.URL.revokeObjectURL(url);
		  });
	}
}